import { z } from 'zod';

const tId = z.union([z.string(), z.number()]);

const tStoreAuditLogOptional = z
  .object({
    store_id: z.number(),
    metadata: z.unknown(),
    source_application: z.string(),
    ip: z.string().nullable(),
  })
  .partial();

const tStoreAuditLogObject = z.intersection(
  z
    .object({
      name: z.string(),
      type: z.string(),
      crm_provider: z.string(),
      schedule_type: z.string(),
    })
    .partial(),

  z.record(z.string(), z.unknown())
);

const tStoreAuditLogRequired = z.object({
  id: tId,
  whodunnit: z.string(),
  created_at: z.number(),
  item_id: z.number(),
  item_type: z.string(),
  event: z.string(),
  actor_type: z.string(),
  actor_name: z.string(),
  parent_record_id: z.union([z.number(), z.null()]),
  object: tStoreAuditLogObject,
  changeset: z.unknown(),
});

export const tStoreAuditLog = z.intersection(
  tStoreAuditLogRequired,
  tStoreAuditLogOptional
);

export type StoreAuditLog = z.infer<typeof tStoreAuditLog>;
export type StoreAuditLogObject = z.infer<typeof tStoreAuditLogObject>;
